<template>
    <v-dialog v-model="closeApp" persistent max-width="550px">
        <v-card>
            <v-card-title>
                <v-icon class="mr-2" color="error">fa-circle-exclamation</v-icon>
                Kein Zugriff
            </v-card-title>
            <v-card-text><p>Der ORDER-Manager darf von diesem Benutzer nicht geöffnet werden!</p>
                <p>Die APP wird nun geschlossen.</p></v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn class="primary" @click="logoutApp">
                    <v-icon small class="mr-2">fa-check</v-icon>
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TransferButton from "@/components/general/TransferButton.vue";
import {globalEventBus} from "@/main";
import {ScalesRestRepository} from "@/modules/scales/adapter/rest/ScalesRestRepository";
import GridForm from "@/components/general/GridForm.vue";
import UploadButton from "@/components/general/UploadButton.vue";

@Component({
    components: {UploadButton, GridForm, TransferButton}
})
export default class CloseDialog extends Vue {
    @Prop({required:true})
    private closeApp!:boolean;

    private logoutApp(): void {
        // localStorage.setItem('Auth/userConfig', '');
        // this.$store.commit("Auth/setAuthToken", '');
        // this.$ports.auth.logout();
        this.$router.replace("/login");
    }
}
</script>

<style scoped>

</style>
